"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _javascriptStyleHelpers = require("@uie/javascript-style-helpers");
var _inputs = require("@vds-core/inputs");
var _buttons = require("@vds/buttons");
var _tooltips = require("@vds/tooltips");
var _layout = require("@vds-tokens/layout");
var _theme = require("@vds/theme");
var _CreditCardIcon = _interopRequireDefault(require("./assets/CreditCardIcon"));
var propTypes = {
  /**
   * @ignore If passed, a background color will be passed to the input
   */
  errorBackgroundColor: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].string]),
  /**
   * @ignore string representing the input's border bottom width
   */
  borderBottomWidth: _propTypes["default"].string,
  /**
   * @ignore If true, sets the error state border bottom with to heavy
   */
  heavyErrorBorder: _propTypes["default"].bool,
  /**
   * Component will render in Inverted state.
   */
  inverted: _propTypes["default"].bool,
  /**
   * @deprecated
   * If provided, the input will be rendered in the ReadOnly state
   */
  locked: _propTypes["default"].bool,
  /**
   * String, array or node containing the title of the TooltipDialog
   */
  tooltipTitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].node]),
  /**
   * String, array or node containing the body content of the TooltipDialog
   */
  tooltipContent: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].node])
};
var defaultProps = {
  inverted: false,
  locked: false
};
var getBorderColor = function getBorderColor(disabled, surface, error, success, focused, hovered, isOpen, heavyErrorBorder) {
  return (isOpen || focused) && surface === "light" ? _theme.colors.black : isOpen && surface === "dark" && error ? _theme.colors.coolGray10 : (isOpen || focused) && surface === "dark" ? _theme.colors.white : error && !disabled ? _theme.colors.error : success && !disabled ? _theme.colors.green : surface === "dark" ? _theme.colors.coolGray10 : _theme.colors.coolGray3;
};
var getBorderBottomColor = function getBorderBottomColor(disabled, surface, error, success, focused, hovered, isOpen) {
  return disabled && surface === "light" ? _theme.colors.coolGray3 : disabled && surface === "dark" ? _theme.colors.coolGray10 : surface === "dark" ? _theme.colors.white : _theme.colors.black;
};
var getBorderBackground = function getBorderBackground(error) {
  return error ? _theme.colors.error : _theme.colors.green;
};
var calculateMinWidth = function calculateMinWidth(type, minWidth) {
  if (type === "password") {
    if (minWidth) {
      var trueMinWidth = parseInt(minWidth) >= 66 ? minWidth : 66;
      return typeof trueMinWidth === "number" ? (0, _javascriptStyleHelpers.calculateRem)(trueMinWidth) : trueMinWidth;
    } else {
      return (0, _javascriptStyleHelpers.calculateRem)(182);
    }
  } else if (type === "inlineAction") {
    return (0, _javascriptStyleHelpers.calculateRem)(182);
  } else if (type === "creditCard") {
    return (0, _javascriptStyleHelpers.calculateRem)(282);
  } else if (type === "date") {
    return (0, _javascriptStyleHelpers.calculateRem)(162);
  } else if (type === "tel") {
    return (0, _javascriptStyleHelpers.calculateRem)(161);
  } else if (type === "securityCode") {
    return (0, _javascriptStyleHelpers.calculateRem)(106);
  } else if (type === "calendar") {
    return (0, _javascriptStyleHelpers.calculateRem)(168);
  } else {
    return (0, _javascriptStyleHelpers.calculateRem)(66);
  }
};

// Extract tooltip's props from core to re-apply inverted
var _renderTooltip = function _renderTooltip(tooltipCoreProps) {
  return /*#__PURE__*/_react["default"].createElement(_tooltips.Tooltip, (0, _extends2["default"])({}, tooltipCoreProps, {
    inverted: tooltipCoreProps.surface === "dark"
  }));
};

// Extract textLink's props from core to re-apply inverted
var _renderTextLink = function _renderTextLink(textLinkCoreProps) {
  return /*#__PURE__*/_react["default"].createElement(_buttons.TextLink, (0, _extends2["default"])({}, textLinkCoreProps, {
    inverted: textLinkCoreProps.surface === "dark"
  }));
};
var InputField = function InputField(props) {
  return /*#__PURE__*/_react["default"].createElement(_inputs.InputField, (0, _extends2["default"])({}, props, {
    readOnly: props.readOnly || props.locked,
    surface: props.inverted ? "dark" : "light",
    renderSecurityCodeTooltipDialog: false // Brand 3.0 only
    ,
    transparentBackground: false // Brand3 only
    ,
    TextLink: _renderTextLink,
    heavyErrorBorder: true,
    errorBackgroundColor: "transparent",
    borderBottomWidth: _layout.LayoutTokens.space["1X"].value,
    Tooltip: _renderTooltip,
    maxWidth: (0, _javascriptStyleHelpers.calculateRem)(596),
    minWidth: calculateMinWidth(props.type, props.minWidth),
    getBorderColor: getBorderColor,
    getBorderBottomColor: getBorderBottomColor,
    getBorderBackground: getBorderBackground,
    CreditCardIcon: _CreditCardIcon["default"]
  }));
};
InputField.propTypes = propTypes;
InputField.defaultProps = defaultProps;
var _default = exports["default"] = InputField;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/inputs/dist/cjs/components/InputField/InputField.js
// module id = 1448
// module chunks = 0